import * as React from 'react'

export default function H1 (props) {
  return (
    <h1 {...props} />
  )
}
